import { groupLifeService } from '@/services';
import type { BusinessUnderwritingMessagesResponse } from '@/services/quotes/types';
import { useQuery } from '@tanstack/react-query';

/**
 * Critérios de subscrição do PME (grade "Critérios de Aceitação").
 *
 * Sempre busca de novo ao montar: a Api reavalia na LEITURA os critérios
 * decididos pelo portal (Grupo Segurável, Verificação de Compliance), e o
 * status da proposta muda fora desta tela (Confirmar do corretor, decisão da
 * mesa). Com o `staleTime` global de 5 min a grade reaparecia sem o critério
 * que acabou de levar a proposta para a análise, até um F5.
 */
export function useGroupLifeUnderwritingMessages(
  policyId: string | undefined,
  enabled = true,
) {
  return useQuery<BusinessUnderwritingMessagesResponse>({
    queryKey: ['group-life', 'underwriting-messages', policyId],
    queryFn: async () => {
      if (!policyId) {
        throw new Error('policyId é obrigatório');
      }
      const response = await groupLifeService.getUnderwritingMessages(policyId);
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar mensagens de subscrição',
        );
      }
      return response.data;
    },
    enabled: enabled && Boolean(policyId),
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
